import React, { FC, useMemo } from "react"
import { SchemaForm } from "universal-schema/lib"
import { DataAccessContext } from "../../../../../../../../../Context/DataAccessContext"
import { useJobResponse } from "../../../../../../../../../Hooks/useJobResponse"
import { useUrlSigner } from "../../../../../../../../../Hooks/useUrlSigner"
import {
    APIJobModel,
    APIJobQueryModel
} from "../../../../../../../../../Models/API/JobModel"
import { DataAccess } from "../../../../../../../../../Models/Client/DataAccess"
import { getValue } from "../../../../../../../../../Models/Client/FetchState"
import { FilterAndSortExpression } from "../../../../../../../../../Models/Client/FilterAndSortExpression"
import { ProjectRole } from "../../../../../../../../../Models/Client/ProjectRole"
import { APIAppInstanceState } from "../../../../../../../../../Reducers/API/AppInstance/AppInstanceReducer"
import { DataPointVersionListItem } from "../../../../../../Common/DataPointVersionListItem/DataPointVersionListItem"
import { JobDetailView } from "../../../../DetailView/Job/JobDetailView_deprecated"

interface JobContentDetailViewerProps {
    orgUsername: string
    appID: string
    detailedJob: APIJobModel
    inputSchema: SchemaForm
    outputSchema: SchemaForm
    appInstance: APIAppInstanceState
    filterAndSort: FilterAndSortExpression<APIJobQueryModel>
    role: ProjectRole[]
}

export const JobContentDetailViewer: FC<JobContentDetailViewerProps> = ({
    orgUsername,
    appID,
    detailedJob,
    appInstance,
    inputSchema,
    outputSchema,
    filterAndSort,
    role
}) => {
    const jobResponseFetch = useJobResponse(appID, detailedJob?.id)

    const dataAccess = useMemo(() => {
        return DataAccess.perJob(detailedJob.id)
    }, [detailedJob])

    const urlSigner = useUrlSigner(dataAccess)

    const versionsList = useMemo(() => {
        if (detailedJob === undefined) {
            return []
        }

        const jobResponse = getValue(jobResponseFetch)

        const currentJobCreationDate =
            detailedJob.created === "" ? null : new Date(detailedJob.created)

        const currentJobVersionName = "Latest Version"

        return [
            {
                jobID: detailedJob.id,
                versionJobId: detailedJob.id,
                originalJobId: detailedJob.id,
                value: 0,
                versionName: currentJobVersionName,
                correct: detailedJob.correct,
                status: detailedJob.status,
                created: currentJobCreationDate,
                isLatestVersion: true,
                response: jobResponse?.response,
                responseData: jobResponse?.responseData,
                label: (
                    <DataPointVersionListItem
                        created={currentJobCreationDate}
                        correct={detailedJob.correct}
                        status={detailedJob.status}
                        version={currentJobVersionName}
                        jobType={detailedJob.jobType}
                    />
                )
            }
        ]
    }, [detailedJob, jobResponseFetch])

    return (
        <DataAccessContext.Provider value={dataAccess}>
            <JobDetailView
                orgUsername={orgUsername}
                job={detailedJob}
                appID={appID}
                instance={appInstance}
                inputSchema={inputSchema}
                outputSchema={outputSchema}
                isJobRelabeled={false}
                prelabels={undefined}
                selectedVersion={0}
                urlSigner={urlSigner}
                versionsList={versionsList}
                wasTaskListToggled
                showOldVersion={false}
                enableTaskList={false}
                clearFilterOnCloseModal={false}
                filterAndSort={filterAndSort}
                edit="not_allowed"
                postProcessedData="not_available"
                showBreadcrumbs={false}
                role={role}
                taskList={[]}
            />
        </DataAccessContext.Provider>
    )
}
